// Duits (de-DE), cultureApp: zelfde vorm als cultureApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appCultureDe = {
    hidden: {
        groupFaithNone: 'Ausgeblendet, weil ihr bei Glaube „Kein Glaube“ gewählt habt',
        searchHidden: 'Ausgeblendete Optionen',
    },
    kitchens: {
        filterLabel: 'Küche',
        all: 'Alle Küchen',
    },
    menu: {
        suggestionsTitle: 'Vorschläge für diese Woche',
        suggestionsHint: 'Tippe auf einen Vorschlag und wähle einen Tag.',
        noSuggestions: 'Keine Vorschläge mehr für diese Woche.',
        whoEats: 'Wer isst mit?',
        everyoneEats: 'Alle essen mit',
        notEating: '{names} isst nicht mit',
        markerLabel: 'Achtung bei diesem Gericht: {text}',
        chooseDay: 'Wähle einen Tag für {title}',
    },
    warning: {
        title: 'Passt das für alle?',
        swapped: 'Getauscht: {swap} statt {ingredient}.',
        eatsOtherSaved: 'Gemerkt: {name} isst bei diesem Gericht etwas anderes.',
        added: 'Hinzugefügt.',
    },
    recipes: {
        original: '{name}',
    },
};
//# sourceMappingURL=cultureApp.de.js.map